// @flow

import type { Action } from './store.type';
import { PredictiveBundleWidgetType } from 'src/models/bundle';

type PredictiveBundlesSuccess = {
  data: Array<PredictiveBundleWidgetType>,
  total: number
};

type PredictiveBundleFailure = {
  error: any
};

export type PredictiveBundleParams = {
  q?: string,
  skip?: number,
  limit?: number
};

/* #region: Get dynamic bundle list */
export const GET_PREDICTIVE_BUNDLE_LIST_REQUEST = 'GET_PREDICTIVE_BUNDLE_LIST_REQUEST';
type GET_PREDICTIVE_BUNDLE_LIST_REQUEST_TYPE = 'GET_PREDICTIVE_BUNDLE_LIST_REQUEST';

export const GET_PREDICTIVE_BUNDLE_LIST_SUCCESS = 'GET_PREDICTIVE_BUNDLE_LIST_SUCCESS';
type GET_PREDICTIVE_BUNDLE_LIST_SUCCESS_TYPE = 'GET_PREDICTIVE_BUNDLE_LIST_SUCCESS';

export const GET_PREDICTIVE_BUNDLE_LIST_FAILURE = 'GET_PREDICTIVE_BUNDLE_LIST_FAILURE';
type GET_PREDICTIVE_BUNDLE_LIST_FAILURE_TYPE = 'GET_PREDICTIVE_BUNDLE_LIST_FAILURE';

type GetPredictiveBundleListRequestAction = Action<GET_PREDICTIVE_BUNDLE_LIST_REQUEST_TYPE, null>;

type GetPredictiveBundleListSuccessAction = Action<
  GET_PREDICTIVE_BUNDLE_LIST_SUCCESS_TYPE,
  { data: PredictiveBundlesSuccess }
>;

type GetPredictiveBundleListFailureAction = Action<
  GET_PREDICTIVE_BUNDLE_LIST_FAILURE_TYPE,
  PredictiveBundleFailure
>;
/* #endregion */

/* #region: Get dynamic bundle widget */
export const GET_PREDICTIVE_BUNDLE_WIDGET_REQUEST = 'GET_PREDICTIVE_BUNDLE_WIDGET_REQUEST';
type GET_PREDICTIVE_BUNDLE_WIDGET_REQUEST_TYPE = 'GET_PREDICTIVE_BUNDLE_WIDGET_REQUEST';

export const GET_PREDICTIVE_BUNDLE_WIDGET_SUCCESS = 'GET_PREDICTIVE_BUNDLE_WIDGET_SUCCESS';
type GET_PREDICTIVE_BUNDLE_WIDGET_SUCCESS_TYPE = 'GET_PREDICTIVE_BUNDLE_WIDGET_SUCCESS';

export const GET_PREDICTIVE_BUNDLE_WIDGET_FAILURE = 'GET_PREDICTIVE_BUNDLE_WIDGET_FAILURE';
type GET_PREDICTIVE_BUNDLE_WIDGET_FAILURE_TYPE = 'GET_PREDICTIVE_BUNDLE_WIDGET_FAILURE';

type GetPredictiveBundleWidgetRequestAction = Action<
  GET_PREDICTIVE_BUNDLE_WIDGET_REQUEST_TYPE,
  null
>;

type GetPredictiveBundleWidgetSuccessAction = Action<
  GET_PREDICTIVE_BUNDLE_WIDGET_SUCCESS_TYPE,
  {
    data: PredictiveBundleWidgetType
  }
>;

type GetPredictiveBundleWidgetFailureAction = Action<
  GET_PREDICTIVE_BUNDLE_WIDGET_FAILURE_TYPE,
  PredictiveBundleFailure
>;
/* #endregion */

/* #region: Delete recommendation widget */
export const DELETE_PREDICTIVE_BUNDLE_WIDGET_REQUEST = 'DELETE_PREDICTIVE_BUNDLE_WIDGET_REQUEST';
type DELETE_PREDICTIVE_BUNDLE_WIDGET_REQUEST_TYPE = 'DELETE_PREDICTIVE_BUNDLE_WIDGET_REQUEST';

export const DELETE_PREDICTIVE_BUNDLE_WIDGET_SUCCESS = 'DELETE_PREDICTIVE_BUNDLE_WIDGET_SUCCESS';
type DELETE_PREDICTIVE_BUNDLE_WIDGET_SUCCESS_TYPE = 'DELETE_PREDICTIVE_BUNDLE_WIDGET_SUCCESS';

export const DELETE_PREDICTIVE_BUNDLE_WIDGET_FAILURE = 'DELETE_PREDICTIVE_BUNDLE_WIDGET_FAILURE';
type DELETE_PREDICTIVE_BUNDLE_WIDGET_FAILURE_TYPE = 'DELETE_PREDICTIVE_BUNDLE_WIDGET_FAILURE';

type DeletePredictiveBundleWidgetRequestAction = Action<
  DELETE_PREDICTIVE_BUNDLE_WIDGET_REQUEST_TYPE,
  null
>;

type DeletePredictiveBundleWidgetSuccessAction = Action<
  DELETE_PREDICTIVE_BUNDLE_WIDGET_SUCCESS_TYPE,
  { data: PredictiveBundleWidgetType }
>;

type DeletePredictiveBundleWidgetFailureAction = Action<
  DELETE_PREDICTIVE_BUNDLE_WIDGET_FAILURE_TYPE,
  PredictiveBundleFailure
>;

export const RESET_PREDICTIVE_BUNDLE_WIDGET = 'RESET_PREDICTIVE_BUNDLE_WIDGET';

/* #region: Create dynamic bundle widget  */
export const CREATE_PREDICTIVE_BUNDLE_WIDGET_REQUEST = 'CREATE_PREDICTIVE_BUNDLE_WIDGET_REQUEST';
type CREATE_PREDICTIVE_BUNDLE_WIDGET_REQUEST_TYPE = 'CREATE_PREDICTIVE_BUNDLE_WIDGET_REQUEST';

export const CREATE_PREDICTIVE_BUNDLE_WIDGET_SUCCESS = 'CREATE_PREDICTIVE_BUNDLE_WIDGET_SUCCESS';
type CREATE_PREDICTIVE_BUNDLE_WIDGET_SUCCESS_TYPE = 'CREATE_PREDICTIVE_BUNDLE_WIDGET_SUCCESS';

export const CREATE_PREDICTIVE_BUNDLE_WIDGET_FAILURE = 'CREATE_PREDICTIVE_BUNDLE_WIDGET_FAILURE';
type CREATE_PREDICTIVE_BUNDLE_WIDGET_FAILURE_TYPE = 'CREATE_PREDICTIVE_BUNDLE_WIDGET_FAILURE';

type CreatePredictiveBundleWidgetAction = Action<
  CREATE_PREDICTIVE_BUNDLE_WIDGET_REQUEST_TYPE,
  null
>;

type CreatePredictiveBundleWidgetSuccessAction = Action<
  CREATE_PREDICTIVE_BUNDLE_WIDGET_SUCCESS_TYPE,
  { data: PredictiveBundleWidgetType }
>;

type CreatePredictiveBundleWidgetFailureAction = Action<
  CREATE_PREDICTIVE_BUNDLE_WIDGET_FAILURE_TYPE,
  PredictiveBundleFailure
>;
/* #endregion */

/* #region: Update recommendation widget*/
export const UPDATE_PREDICTIVE_BUNDLE_WIDGET_REQUEST = 'UPDATE_PREDICTIVE_BUNDLE_WIDGET_REQUEST';
type UPDATE_PREDICTIVE_BUNDLE_WIDGET_REQUEST_TYPE = 'UPDATE_PREDICTIVE_BUNDLE_WIDGET_REQUEST';

export const UPDATE_PREDICTIVE_BUNDLE_WIDGET_SUCCESS = 'UPDATE_PREDICTIVE_BUNDLE_WIDGET_SUCCESS';
type UPDATE_PREDICTIVE_BUNDLE_WIDGET_SUCCESS_TYPE = 'UPDATE_PREDICTIVE_BUNDLE_WIDGET_SUCCESS';

export const UPDATE_PREDICTIVE_BUNDLE_WIDGET_FAILURE = 'UPDATE_PREDICTIVE_BUNDLE_WIDGET_FAILURE';
type UPDATE_PREDICTIVE_BUNDLE_WIDGET_FAILURE_TYPE = 'UPDATE_PREDICTIVE_BUNDLE_WIDGET_FAILURE';

type UpdatePredictiveBundleWidgetRequestAction = Action<
  UPDATE_PREDICTIVE_BUNDLE_WIDGET_REQUEST_TYPE,
  null
>;

type UpdatePredictiveBundleWidgetSuccessAction = Action<
  UPDATE_PREDICTIVE_BUNDLE_WIDGET_SUCCESS_TYPE,
  { data: PredictiveBundleWidgetType }
>;

type UpdatePredictiveBundleWidgetFailureAction = Action<
  UPDATE_PREDICTIVE_BUNDLE_WIDGET_FAILURE_TYPE,
  PredictiveBundleFailure
>;
/* #endregion */

/* #region: Update recommendation widget action */
export const UPDATE_PREDICTIVE_BUNDLE_WIDGET_ACTION_REQUEST =
  'UPDATE_PREDICTIVE_BUNDLE_WIDGET_ACTION_REQUEST';
type UPDATE_PREDICTIVE_BUNDLE_WIDGET_ACTION_REQUEST_TYPE =
  'UPDATE_PREDICTIVE_BUNDLE_WIDGET_ACTION_REQUEST';

export const UPDATE_PREDICTIVE_BUNDLE_WIDGET_ACTION_SUCCESS =
  'UPDATE_PREDICTIVE_BUNDLE_WIDGET_ACTION_SUCCESS';
type UPDATE_PREDICTIVE_BUNDLE_WIDGET_ACTION_SUCCESS_TYPE =
  'UPDATE_PREDICTIVE_BUNDLE_WIDGET_ACTION_SUCCESS';

export const UPDATE_PREDICTIVE_BUNDLE_WIDGET_ACTION_FAILURE =
  'UPDATE_PREDICTIVE_BUNDLE_WIDGET_ACTION_FAILURE';
type UPDATE_PREDICTIVE_BUNDLE_WIDGET_ACTION_FAILURE_TYPE =
  'UPDATE_PREDICTIVE_BUNDLE_WIDGET_ACTION_FAILURE';

type UpdatePredictiveBundleWidgetActionRequestAction = Action<
  UPDATE_PREDICTIVE_BUNDLE_WIDGET_ACTION_REQUEST_TYPE,
  null
>;

type UpdatePredictiveBundleWidgetActionSuccessAction = Action<
  UPDATE_PREDICTIVE_BUNDLE_WIDGET_ACTION_SUCCESS_TYPE,
  { data: PredictiveBundleWidgetType }
>;

type UpdatePredictiveBundleWidgetActionFailureAction = Action<
  UPDATE_PREDICTIVE_BUNDLE_WIDGET_ACTION_FAILURE_TYPE,
  PredictiveBundleFailure
>;
/* #endregion */

/* #region: Get sync order status */
export const GET_SYNC_ORDER_STATUS_BUNDLE_REQUEST = 'GET_SYNC_ORDER_STATUS_BUNDLE_REQUEST';
type GET_SYNC_ORDER_STATUS_BUNDLE_REQUEST_TYPE = 'GET_SYNC_ORDER_STATUS_BUNDLE_REQUEST';

export const GET_SYNC_ORDER_STATUS_BUNDLE_SUCCESS = 'GET_SYNC_ORDER_STATUS_BUNDLE_SUCCESS';
type GET_SYNC_ORDER_STATUS_BUNDLE_SUCCESS_TYPE = 'GET_SYNC_ORDER_STATUS_BUNDLE_SUCCESS';

export const GET_SYNC_ORDER_STATUS_BUNDLE_FAILURE = 'GET_SYNC_ORDER_STATUS_BUNDLE_FAILURE';
type GET_SYNC_ORDER_STATUS_BUNDLE_FAILURE_TYPE = 'GET_SYNC_ORDER_STATUS_BUNDLE_FAILURE';

type GetSyncOrderStatusAction = Action<GET_SYNC_ORDER_STATUS_BUNDLE_REQUEST_TYPE, null>;

type GetSyncOrderStatusSuccessAction = Action<
  GET_SYNC_ORDER_STATUS_BUNDLE_SUCCESS_TYPE,
  { syncType: '' | '90' | '30', status: 'running' | 'done' }
>;

type GetSyncOrderStatusFailureAction = Action<
  GET_SYNC_ORDER_STATUS_BUNDLE_FAILURE_TYPE,
  PredictiveBundleFailure
>;
/* #endregion */

/* #region: Sync bundle widget status */
export const SYNC_BUNDLE_WIDGETS_REQUEST = 'SYNC_BUNDLE_WIDGETS_REQUEST';
type SYNC_BUNDLE_WIDGETS_REQUEST_TYPE = 'SYNC_BUNDLE_WIDGETS_REQUEST';

export const SYNC_BUNDLE_WIDGETS_SUCCESS = 'SYNC_BUNDLE_WIDGETS_SUCCESS';
type SYNC_BUNDLE_WIDGETS_SUCCESS_TYPE = 'SYNC_BUNDLE_WIDGETS_SUCCESS';

export const SYNC_BUNDLE_WIDGETS_FAILURE = 'SYNC_BUNDLE_WIDGETS_FAILURE';
type SYNC_BUNDLE_WIDGETS_FAILURE_TYPE = 'SYNC_BUNDLE_WIDGETS_FAILURE';

type SyncBundleWidgetsRequestAction = Action<SYNC_BUNDLE_WIDGETS_REQUEST_TYPE, null>;

type SyncBundleWidgetsSuccessAction = Action<
  SYNC_BUNDLE_WIDGETS_SUCCESS_TYPE,
  { data: ListManualRecommendationResponseType }
>;

type SyncBundleWidgetsFailureAction = Action<
  SYNC_BUNDLE_WIDGETS_FAILURE_TYPE,
  RecommendationFailure
>;

/* #region: Get sync order status */
export const GET_PREDICTIVE_BUNDLE_DEFAULT_DESIGN_SETTINGS_REQUEST =
  'GET_PREDICTIVE_BUNDLE_DEFAULT_DESIGN_SETTINGS_REQUEST';
type GET_PREDICTIVE_BUNDLE_DEFAULT_DESIGN_SETTINGS_REQUEST_TYPE =
  'GET_PREDICTIVE_BUNDLE_DEFAULT_DESIGN_SETTINGS_REQUEST';

export const GET_PREDICTIVE_BUNDLE_DEFAULT_DESIGN_SETTINGS_SUCCESS =
  'GET_PREDICTIVE_BUNDLE_DEFAULT_DESIGN_SETTINGS_SUCCESS';
type GET_PREDICTIVE_BUNDLE_DEFAULT_DESIGN_SETTINGS_SUCCESS_TYPE =
  'GET_PREDICTIVE_BUNDLE_DEFAULT_DESIGN_SETTINGS_SUCCESS';

export const GET_PREDICTIVE_BUNDLE_DEFAULT_DESIGN_SETTINGS_FAILURE =
  'GET_PREDICTIVE_BUNDLE_DEFAULT_DESIGN_SETTINGS_FAILURE';
type GET_PREDICTIVE_BUNDLE_DEFAULT_DESIGN_SETTINGS_FAILURE_TYPE =
  'GET_PREDICTIVE_BUNDLE_DEFAULT_DESIGN_SETTINGS_FAILURE';

type GetPredictiveBundleDefaultDesignSettingsRequestAction = Action<
  GET_PREDICTIVE_BUNDLE_DEFAULT_DESIGN_SETTINGS_REQUEST_TYPE,
  null
>;

type GetPredictiveBundleDefaultDesignSettingsSuccessAction = Action<
  GET_PREDICTIVE_BUNDLE_DEFAULT_DESIGN_SETTINGS_SUCCESS_TYPE,
  { isEnableAppBoostCore: boolean, isEnableAppBlock: boolean }
>;

type GetPredictiveBundleDefaultDesignSettingsFailureAction = Action<
  GET_PREDICTIVE_BUNDLE_DEFAULT_DESIGN_SETTINGS_FAILURE_TYPE,
  RecommendationFailure
>;
/* #endregion */

// Action and State
export type RecommendationAction =
  | GetPredictiveBundleListRequestAction
  | GetPredictiveBundleListSuccessAction
  | GetPredictiveBundleListFailureAction
  | GetPredictiveBundleWidgetRequestAction
  | GetPredictiveBundleWidgetSuccessAction
  | GetPredictiveBundleWidgetFailureAction
  | DeletePredictiveBundleWidgetRequestAction
  | DeletePredictiveBundleWidgetSuccessAction
  | DeletePredictiveBundleWidgetFailureAction
  | CreatePredictiveBundleWidgetAction
  | CreatePredictiveBundleWidgetSuccessAction
  | CreatePredictiveBundleWidgetFailureAction
  | UpdatePredictiveBundleWidgetRequestAction
  | UpdatePredictiveBundleWidgetSuccessAction
  | UpdatePredictiveBundleWidgetFailureAction
  | UpdatePredictiveBundleWidgetActionRequestAction
  | UpdatePredictiveBundleWidgetActionSuccessAction
  | UpdatePredictiveBundleWidgetActionFailureAction
  | GetSyncOrderStatusAction
  | GetSyncOrderStatusSuccessAction
  | GetSyncOrderStatusFailureAction
  | SyncBundleWidgetsRequestAction
  | SyncBundleWidgetsSuccessAction
  | SyncBundleWidgetsFailureAction
  | GetPredictiveBundleDefaultDesignSettingsRequestAction
  | GetPredictiveBundleDefaultDesignSettingsSuccessAction
  | GetPredictiveBundleDefaultDesignSettingsFailureAction;
